module.exports = __webpack_public_path__ + "img/528-42dfb3.png";